import type { SearchBarState } from "@/features/search/types";
import { parseCategoryKeys, parseCategoryNames } from "./category-selection";

function countSelectedCategories(state: Pick<SearchBarState, "category" | "categoryName">): number {
  const keys = parseCategoryKeys(state.category);
  if (keys.length > 0) return keys.length;
  return parseCategoryNames(state.categoryName).length;
}

function formatTreatmentLabel(
  state: Pick<SearchBarState, "query" | "category" | "categoryName">,
): string {
  const query = state.query?.trim();
  if (query) return query;

  const names = parseCategoryNames(state.categoryName);
  const count = countSelectedCategories(state);

  if (count > 2) return `${count} treatments`;
  if (names.length > 0) return names.join(", ");
  return "All treatments";
}

export { formatTreatmentLabel };
